export const environment = {
  production: false,
  env: 'development',
  API_URL: 'https://api.dev.datastorio.cloud',
  OPERATIONS_API_URL: 'https://api.dev.datastorio.cloud',
  KEYCLOAK_URL: 'https://auth.dev.datastorio.cloud',
  FRONTEND_URL: 'http://admin.dev.datastor.io'
};
